import { injectIntl as withIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { pushPage } from '@shared/actions';
import trackModalClosed from '@tracking/actions/trackModalClosed';
import trackModalOpened from '@tracking/actions/trackModalOpened';
import fetchReliableAgeValidation from '@core/reducers/cart/actions/fetchReliableAgeValidation';

const mapDispatchToProps = {
  trackModalClosed,
  trackModalOpened,
  trackAgeValidationFailed: () => {},
  fetchReliableAgeValidation,
  pushPage,
};

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect, withIntl);
